// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.unknown-platform-modal_modal-content_zdXL0 {
    max-width: 480px;
    margin-top: 50px;
}

.unknown-platform-modal_body_Wh_dp {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
    max-height: calc(100vh - 150px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.unknown-platform-modal_details_ppEE0 {
    font-family: monospace;
    -webkit-user-select: text;
       -moz-user-select: text;
        -ms-user-select: text;
            user-select: text;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.unknown-platform-modal_details_ppEE0::before, .unknown-platform-modal_details_ppEE0::after {
    content: '"';
}

.unknown-platform-modal_button_J02D2 {
    font: inherit;
    font-weight: bold;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    background-color: var(--looks-secondary);
    color: white;
}

.unknown-platform-modal_button_J02D2:disabled {
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-unknown-platform-modal/unknown-platform-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    max-width: 480px;\n    margin-top: 50px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n    max-height: calc(100vh - 150px);\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.details {\n    font-family: monospace;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n    text-wrap: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.details::before, .details::after {\n    content: '\"';\n}\n\n.button {\n    font: inherit;\n    font-weight: bold;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    background-color: var(--looks-secondary);\n    color: white;\n}\n\n.button:disabled {\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `unknown-platform-modal_modal-content_zdXL0`;
export { _1 as "modal-content" };
export var modalContent = `unknown-platform-modal_modal-content_zdXL0`;
export var body = `unknown-platform-modal_body_Wh_dp`;
export var details = `unknown-platform-modal_details_ppEE0`;
export var button = `unknown-platform-modal_button_J02D2`;
export default ___CSS_LOADER_EXPORT___;
